module.exports = __webpack_public_path__ + "static/media/QR_code.98613185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QR_code.png
// module id = 89
// module chunks = 0